webpackJsonp([279802917561594],{

/***/ 434:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/corning/"},"frontmatter":{"title":"Corning"}}}]}},"pathContext":{"tag":"Corning"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-corning-a4ceb8594a3627a37928.js